import React, {useContext, useEffect, useRef, useState} from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Input, FormGroup, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import UiContent from "../../../../Components/Common/UiContent";
import BetterStandsContext from "../../../../Components/Contexts/Management/BetterStandsContext";
import UygunsuzlukModal from "../../Forms/UygunsuzlukModal";
import UygunsuzlukDetailModal from "../../../../Components/Saha/UygunsuzlukDetailModal";
import axios from 'axios';
import DOFForm from "../../Forms/DOFForm";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";
const tableStyles = {
    tableResponsive: {
        overflowX: 'auto',
        width: '100%'
    },
    table: {
        width: '100%'
    },
    cell: {
        wordBreak: 'break-word',
        maxWidth: '200px'
    }
};
const ConstantElektrikUygunsuzluk = () => {
  const { t } = useTranslation("saha");
    useEffect(() => { document.title = i18n.t("saha:constantElektrikUygunsuzluk.n24SaatElektrikUygunsuzluklar"); }, []);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [uyumsuzluklar, setUyumsuzluklar] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUyumsuzluk, setSelectedUyumsuzluk] = useState(null);
    const [newUygunsuzlukModalOpen, setNewUygunsuzlukModalOpen] = useState(false);
    const [dofModalOpen, setDofModalOpen] = useState(false);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const prevModalStates = useRef({ newUygunsuzluk: false, dof: false });
    const { fetchActiveFairId, activeFairId } = useContext(BetterStandsContext);

    useEffect(() => {
        const initializePage = async () => {
            setLoading(true);
            try {
                const userId = localStorage.getItem('userId');
                if (!userId) {
                    console.error("User ID not found in localStorage");
                    return;
                }
                await fetchActiveFairId(userId);
            } catch (error) {
                console.error("Error initializing page:", error);
            } finally {
                setLoading(false);
            }
        };

        initializePage();
    }, [fetchActiveFairId]);

    useEffect(() => {
        if (activeFairId) {
            fetchUyumsuzluklar();
        }
    }, [activeFairId, searchTerm]);

    useEffect(() => {
        if ((prevModalStates.current.newUygunsuzluk && !newUygunsuzlukModalOpen) ||
            (prevModalStates.current.dof && !dofModalOpen)) {
            fetchUyumsuzluklar().then(() => {
                console.log("Uygunsuzluklar yenilendi");
            });
        }

        prevModalStates.current = {
            newUygunsuzluk: newUygunsuzlukModalOpen,
            dof: dofModalOpen
        };
    }, [newUygunsuzlukModalOpen, dofModalOpen]);


    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const openDetailModal = (uyumsuzluk) => {

        setSelectedUyumsuzluk(uyumsuzluk);
        setModalOpen(true);
    };

    const closeDetailModal = () => {
        setSelectedUyumsuzluk(null);
        setModalOpen(false);
    };

    const openDeleteConfirmation = () => {
        setDeleteConfirmationOpen(true);
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmationOpen(false);
    };

    const handleDeleteConfirm = async () => {
        if (!selectedUyumsuzluk) return;
        
        setDeleteLoading(true);
        try {
            const uygunsuzlukId = selectedUyumsuzluk[0];
            await axios.delete(`https://fds.sakagrup.com/Saha/xDeleteUyumsuzluk/${uygunsuzlukId}`);
            
            closeDeleteConfirmation();
            closeDetailModal();
            await fetchUyumsuzluklar();
        } catch (error) {
            console.error("Error deleting uygunsuzluk:", error);
            alert(t("constantElektrikUygunsuzluk.hataUygunsuzlukSilinirkenBirSorun"));
        } finally {
            setDeleteLoading(false);
        }
    };

    const openNewUygunsuzlukModal = () => {
        setNewUygunsuzlukModalOpen(true);
    };

    const closeNewUygunsuzlukModal = () => {
        setNewUygunsuzlukModalOpen(false);
    };

    const openDofModal = (uyumsuzluk) =>{
        setSelectedUyumsuzluk(uyumsuzluk);
        setDofModalOpen(true);
    }

    const closeDofModal = () => {
        setDofModalOpen(false);
    }

    return (
        <React.Fragment>
            <UiContent />
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("constantElektrikUygunsuzluk.n24SaatElektrikUygunsuzluklar2")} pageTitle={t("constantElektrikUygunsuzluk.n24SaatElektrik")} />
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardHeader>
                                    <h4 className="card-title mb-0">{t("constantElektrikUygunsuzluk.uygunsuzlukListesi")}</h4>
                                </CardHeader>
                                <CardBody>
                                    <Row className="g-4 mb-3">
                                        <Col className="col-sm">
                                            <div className="d-flex">
                                                <div className="search-box ms-2">
                                                    <FormGroup className="mb-3">
                                                        <Label for="searchInput">{t("common:ara")}</Label>
                                                        <Input
                                                            id="searchInput"
                                                            type="text"
                                                            value={searchTerm}
                                                            onChange={handleSearch}
                                                            placeholder={t("constantElektrikUygunsuzluk.ara")}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col className="col-sm-auto">
                                            <div>
                                                <Button color="secondary" className="add-btn me-1" onClick={openNewUygunsuzlukModal} id="create-uygunsuzluk-isg"><i className="ri-add-line align-bottom me-1"></i>{" "}{t("constantElektrikUygunsuzluk.uygunsuzlukOlustur")}</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                    {loading ? (
                                        <p>{t("common:yukleniyor")}</p>
                                    ) : uyumsuzluklar.length === 0 ? (
                                        <p>{t("constantElektrikUygunsuzluk.hicUygunsuzlukBulunamadi")}</p>
                                    ) : (
                                        <div style={tableStyles.tableResponsive}>
                                            <Table className="table align-middle table-nowrap" style={tableStyles.table}>
                                                <thead>
                                                <tr>
                                                    <th>{t("constantElektrikUygunsuzluk.id")}</th>
                                                    <th>{t("constantElektrikUygunsuzluk.uygunsuzluk")}</th>
                                                    <th>{t("constantElektrikUygunsuzluk.stant")}</th>
                                                    <th>{t("constantElektrikUygunsuzluk.denetmen")}</th>
                                                    <th>{t("constantElektrikUygunsuzluk.islem")}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {uyumsuzluklar.map((uyumsuzluk) => (
                                                    <tr key={uyumsuzluk[0]}>
                                                        <td style={tableStyles.cell}>{uyumsuzluk[0]}</td>
                                                        <td style={tableStyles.cell}>
                                                            <div style={{ overflow: "hidden" }}>{uyumsuzluk[5]}/</div>
                                                            <div>{uyumsuzluk[2]}/</div>
                                                            <div>{uyumsuzluk[3]}</div>
                                                            <div style={{ overflow: "hidden" }}>{uyumsuzluk[4]}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            <div>{uyumsuzluk[6]}</div>
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            {uyumsuzluk[7]}<br/> {uyumsuzluk[8]}
                                                        </td>
                                                        <td style={tableStyles.cell}>
                                                            <Button color="warning" className="me-2" onClick={() => openDetailModal(uyumsuzluk)}>
                                                                {t("common:detay")}
                                                            </Button>
                                                            <Button color="secondary" onClick={() => openDofModal(uyumsuzluk)}>
                                                                {t("constantElektrikUygunsuzluk.dofOlustur")}
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <UygunsuzlukDetailModal
                isOpen={modalOpen}
                toggle={closeDetailModal}
                selectedUyumsuzluk={selectedUyumsuzluk}
                formTypeId={3}
                activeFairId={activeFairId}
                onDelete={() => {
                    fetchUyumsuzluklar();
                    closeDetailModal();
                }}
            />

            <Modal isOpen={deleteConfirmationOpen} toggle={closeDeleteConfirmation} centered>
                <ModalHeader toggle={closeDeleteConfirmation}>{t("constantElektrikUygunsuzluk.silmeOnayi")}</ModalHeader>
                <ModalBody>
                    <p>{t("constantElektrikUygunsuzluk.buUygunsuzlukKaydiniSilmekIstediginizden")}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeDeleteConfirmation} disabled={deleteLoading}>
                        {t("common:iptal")}
                    </Button>
                    <Button color="danger" onClick={handleDeleteConfirm} disabled={deleteLoading}>
                        {deleteLoading ? t("constantElektrikUygunsuzluk.siliniyor") : t("constantElektrikUygunsuzluk.evetSil")}
                    </Button>
                </ModalFooter>
            </Modal>
            <UygunsuzlukModal
                isOpen={newUygunsuzlukModalOpen}
                toggle={closeNewUygunsuzlukModal}
                formId={3} // or any other relevant ID
                standId={null}
                selectedData={null}
                categoryId={null}
                subId={null}
                konuName={null}
            />
            {selectedUyumsuzluk && (
                <DOFForm
                    isOpen={dofModalOpen}
                    toggle={closeDofModal}
                    formId={3} // or any other relevant ID
                    sahaFormId={selectedUyumsuzluk[0]}
                    selectedData={selectedUyumsuzluk}
                />
            )}
        </React.Fragment>
    );
};

export default ConstantElektrikUygunsuzluk;